import { RequestHookParams, request, useRequest } from 'src/shared/api';
import { RequestByLimitOffset } from 'src/shared/api/request';
import { apiRoutesMap } from 'src/shared/config';
import {
  CertificateResponse,
  CertificateSort,
  StaleCertificatesResponse,
  VerifyCertificatesResponse,
} from './model';

export type StaleListParams = RequestByLimitOffset & {
  /** Поиск: код товара (только цифры) или номер документа, минимум 2 символа. */
  q?: string;
  status?: string;
  sort?: CertificateSort;
};

export const useGetStaleCertificates = (
  params: RequestHookParams<StaleListParams>,
) =>
  useRequest<StaleCertificatesResponse>(
    apiRoutesMap.certificatesStaleList.getRoute(),
    params,
  );

export const useGetCertificate = (id?: number | string | null) => {
  const href = id ? apiRoutesMap.certificates.getRoute(id) : '';

  return useRequest<CertificateResponse>(href, {
    variables: {},
    skip: !href,
  });
};

export const verifyCertificate = (id: number | string) =>
  request.post<VerifyCertificatesResponse>(
    `${apiRoutesMap.certificatesVerify.getRoute(id)}?force=1`,
    {},
  );
